module.exports = __webpack_public_path__ + "static/media/img_4.4dd721f3.png";